<template>
  <Card class="menu-card">
    <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">医馆管理</el-menu-item>
      <el-menu-item index="2">诊室管理</el-menu-item>
      <el-menu-item index="3">科室管理</el-menu-item>
      <el-menu-item index="4">医疗设备</el-menu-item>
      <el-menu-item index="5">叫号屏管理</el-menu-item>
      <el-menu-item index="6">自提/发货时间配置</el-menu-item>
    </el-menu>
    <div slot="content">
      <component :is="componentMap[menuIndex]" />
    </div>
  </Card>
</template>

<script lang="js">
import Dept from "./components/Dept.vue"; // 医馆管理
import Post from "./components/Post.vue"; // 科室管理
import Clinic from "./components/Clinic.vue"; // 诊室管理
import Equipment from './components/Equipment.vue'
import CallingNumbersManage from './components/CallingNumbersManage.vue'
import DeliveryTimeConfiguration from './components/DeliveryTimeConfiguration.vue'
export default {
  name: "StoreManage",
  components: { Post, Dept, Clinic, Equipment, CallingNumbersManage, DeliveryTimeConfiguration },
  data() {
    return {
      componentMap: {
        "1": Dept,
        "2": Clinic,
        "3": Post,
        "4": Equipment,
        "5": CallingNumbersManage,
        "6": DeliveryTimeConfiguration
      },
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('storeIndex');
    if (index) this.activeIndex = this.menuIndex = index;
  },
  mounted() {
    this.judge();
  },
  methods:{
    // 判断是否是名医推荐组件
    judge() {
      let box = document.querySelector('.menu-card').querySelector('.el-card__body');
      if (this.menuIndex == '3') {
        box.classList.add("overflow");
        this.$forceUpdate();
      } else {
        box.classList.remove("overflow");
        this.$forceUpdate();
      }
    },
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key;
      this.$session.set('storeIndex', key);
      this.judge();
    }
  }
};
</script>
<style>
.overflow {
  overflow-y: scroll;
}
</style>